import gql from "graphql-tag";

const RD_QUERY = gql`  
  query Post($id: String!){
    regionalDirector(id: $id) {
      id
      name
      phone
      lookup_id
      first_name
      last_name
      group
      event_coordinator
      event_coordinator_email
      warehouse
    }
  }
`;

export default RD_QUERY;